import store from '@/store/index.js'
let dic = store.state.dic;
import { getOrgOptions } from "@/libs/searchSelect";
export default function Configs(that) {

    const searchItems = [
        {
            label: "学院",
            span: 6,
            type: 'select',
            model: "collegeId",
            options: dic._COLLEGE_OPTIONS,
            clearable: true,
            change(data) {
                that.searchItems[2].options = [];
                that.searchItems[3].options = [];
                that.pageParams.majorId = "";
                that.pageParams.classIdList = [];
                if (data) {
                    let params = {
                        parentId: data,
                        type: 'department',
                    }
                    getOrgOptions(that, params, 1, null);
                    params = {
                        parentId: data,
                        grade: that.pageParams.grade,
                        type: 'class'
                    }
                    that.searchItems[2].options = [];
                    that.pageParams.classIdList = [];
                    getOrgOptions(that, params, 3, null)
                }
            },
        },
        {
            label: "年级",
            span: 6,
            type: 'year',
            model: "grade",
            clearable: true,
            change(data) {
                that.searchItems[3].options = [];
                let parentId = "";
                if (that.pageParams.classIdList &&that.pageParams.classIdList.size>0) {
                    parentId = that.pageParams.classIdList.join(",");
                } else if (that.pageParams.majorId) {
                    parentId = that.pageParams.majorId;
                } else if (that.pageParams.collegeId) {
                    parentId = that.pageParams.collegeId;
                }
                let params = {
                    parentId: parentId,
                    grade: data,
                    type: 'class'
                }
                that.searchItems[3].options = [];
                that.pageParams.classIdList = [];
                getOrgOptions(that, params, 3, null)
            },
        },
        {
            label: "专业",
            span: 6,
            placeholder: '请选择专业',
            type: 'select',
            model: "majorId",
            clearable: true,
            options: [],
            change(data) {
                that.searchItems[3].options = [];
                that.pageParams.classIdList = [];
                let parentId = "";
                if (data) {
                    parentId = data;
                } else if (that.pageParams.collegeId) {
                    parentId = that.pageParams.collegeId;
                }
                let params = {
                    parentId: parentId,
                    grade: that.pageParams.grade,
                    type: 'class'
                }
                getOrgOptions(that, params, 3, null)
            },
        },
        {
            label: "班级",
            span: 6,
            placeholder: '请选择班级',
            type: 'select',
            model: "classIdList",
            multiple:true,
            clearable: true,
            options: [],
        },
        {
            label: "学号",
            prop: "studentNo",
            span: 6,
            model: "studentNo"
        },
        {
            label: "姓名",
            span: 6,
            model: "studentName",
        },
        {
            label: "办理状态",
            span: 6,
            model: "status",
            type: 'select',
            options: [
                { label: '已办理', value: 1 },
                { label: '未办理', value: 0 },
            ]
        },
        {
            label: "培养层次",
            span: 6,
            type: 'select',
            options: dic._DEGREE,
            model: "academicDegree",
            clearable: true,
        },
        {
            label: "学制",
            span: 6,
            type: 'select',
            options: dic._ACADEMICYEAR,
            model: "academicYear",
            clearable: true,
        },
    ]
    const tableColumns = [
        {
            label: "学号",
            prop: "studentNo",
            align: "center",
            show: true,
        },
        {
            label: "姓名",
            prop: "studentName",
            align: "center",
            show: true,
        },
        {
            label: "身份证号",
            prop: "idCard",
            align: "center",
            show: true,
        },
        {
            label: "学院",
            prop: "collegeName",
            align: "center",
            show: true,
        },
        {
            label: "专业",
            prop: "majorName",
            align: "center",
            show: true,
        },
        {
            label: "班级",
            prop: "className",
            align: "center",
            show: true,
        },
        {
            label: "环节名称",
            prop: "linkName",
            align: "center",
            show: true,
        },
        {
            label: "状态",
            // prop: "status",
            name: 'status',
            align: "center",
            show: true
        },
        {
            label: "注意事项",
            prop: "description",
            align: "center",
            show: true
        },
        {
            label: "操作",
            name: "custom",
            align: "center",
            width: '120px',
            show: true
        }
    ]
    const formItems = [
        {
            label: "学号",
            prop: "studentNo",
            span: 8,
            model: "studentNo",
            disabled: true,
        },
        {
            label: "姓名",
            span: 8,
            model: "name",
            disabled: true,
        },
        {
            label: "身份证号",
            span: 8,
            model: "idCard",
            disabled: true,
        },
        {
            label: "学院",
            span: 8,
            model: "collegeName",
            disabled: true,
        },
        // {
        //     label: "系别",
        //     span: 12,
        //     model: "departmentName",
        //     disabled: true,
        // },
        {
            label: "专业",
            span: 8,
            model: "majorName",
            disabled: true,
        },
        // {
        //     label: "班级",
        //     span: 8,
        //     model: "className",
        //     disabled: true,
        // },
    ]

    const formRules = {
    }
    return {
        searchItems,
        tableColumns,
        formItems,
        formRules
    }
}
